<template>
  <div id="sistem-pengawasan">

    <section  id="content" class="px-3 px-lg-5 mt-8">
      <div class="row">
        <div class="col-lg-8">
          <div class="card p-3 bg-primary-50 rounded border-0 shadow-sm">
            <div class="d-flex flex-wrap align-items-center " style="gap: 1rem;">
              <img :src="`https://ui-avatars.com/api/?name=${user.fullname}&background=344054&color=fff&font-size=0.40`" class="rounded-circle" alt="Avatar">
              <div class="mr-auto">
                <h4>{{ user.fullname }}</h4>
                <div class="d-flex align-items-center" style="gap: 0.5rem;">
                  <img src="@/assets/sistem-pengawasan/icon/UserCircle.svg" alt="">
                  <h5 class="m-0">{{ user.role_name }} - <span class="text-muted">Terdaftar sejak 1 tahun yang lalu</span></h5>
                </div>
              </div>
              <!-- <button class="btn btn-primary rounded-pill py-2 px-3">Sunting Profil</button> -->
            </div>
            <div class="card p-3 mt-5 rounded">
              <div class="d-flex flex-wrap justify-content-between" style="gap: 1rem;">
                <div class="d-flex" style="gap: 1rem;">
                  <div class="d-flex rounded align-items-center justify-content-center bg-primary-100 p-4">
                    <img src="@/assets/sistem-pengawasan/icon/laporan.svg" alt="">
                  </div>
                  <div>
                    <h1 class="m-0 text-dark">{{ (profile.statistic && profile.statistic.Semua) ? profile.statistic.Semua : 0 }}</h1>
                    <h5 class="text-muted m-0">Laporan</h5>
                  </div>
                </div>
                <div class="d-flex" style="gap: 1rem;">
                  <div class="d-flex rounded align-items-center justify-content-center p-4" style="background-color: #e6e28a;">
                    <img src="@/assets/sistem-pengawasan/icon/daftar-tunggu.svg" alt="">
                  </div>
                  <div>
                    <h1 class="m-0 text-dark">{{ (profile.statistic && profile.statistic.Terkirim) ? profile.statistic.Terkirim : 0 }}</h1>
                    <h5 class="text-muted m-0">Terkirim</h5>
                  </div>
                </div>
                <div class="d-flex" style="gap: 1rem;">
                  <div class="d-flex rounded align-items-center justify-content-center bg-success-70 p-4">
                    <img src="@/assets/sistem-pengawasan/icon/tindak-lanjut.svg" alt="">
                  </div>
                  <div>
                    <h1 class="m-0 text-dark">{{ (profile.statistic && profile.statistic.Diterima) ? profile.statistic.Diterima : 0 }}</h1>
                    <h5 class="text-muted m-0">Diterima</h5>
                  </div>
                </div>
                <div class="d-flex" style="gap: 1rem;">
                  <div class="d-flex rounded align-items-center justify-content-center bg-danger-50 p-4">
                    <img src="@/assets/sistem-pengawasan/icon/daftar-tunggu.svg" alt="">
                  </div>
                  <div>
                    <h1 class="m-0 text-dark">{{ (profile.statistic && profile.statistic.Ditolak) ? profile.statistic.Ditolak : 0 }}</h1>
                    <h5 class="text-muted m-0">Ditolak</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card p-4 bg-primary-50 rounded border-0 shadow-sm">
            <div class="table-responsive">
              <div class="d-flex py-2" style="gap: 1.5rem">
                  <button @click="filter = 'semua'" :class="`btn px-3 rounded text-muted ${filter === 'semua' ? 'btn-active' : ''}`">
                    <i class="fa fa-list fa-lg mr-1"></i>
                    Semua
                  </button>
                  <button @click="filter = 'terkirim'" :class="`btn px-3 rounded text-muted ${filter === 'terkirim' ? 'btn-active' : ''}`">
                    <i class="fa-solid fa-book-open fa-lg mr-1"></i>
                    Terkirim
                  </button>
                  <button @click="filter = 'diterima'" :class="`btn px-3 rounded text-muted ${filter === 'diterima' ? 'btn-active' : ''}`">
                    <i class="fa fa-file-signature fa-lg mr-1"></i>
                    Diterima
                  </button>
                  <button @click="filter = 'ditolak'" :class="`btn px-3 rounded text-muted ${filter === 'ditolak' ? 'btn-active' : ''}`">
                    <i class="fa fa-circle-xmark fa-lg mr-1"></i>
                    Ditolak
                  </button>
                  <button @click="filter = 'selesai'" :class="`btn px-3 rounded text-muted ${filter === 'selesai' ? 'btn-active' : ''}`">
                    <i class="fa fa-circle-check fa-lg mr-1"></i>
                    Selesai
                  </button>
                </div>
            </div>
            <div class="mt-4">
              <h4 v-if="!filteredReports || filteredReports.length === 0" class="text-center">Belum ada</h4>
              <div v-else v-for="report in filteredReports" :key="report.id" class="card  p-4 bg-white rounded border-0 shadow-sm">
                <div class="d-flex flex-wrap align-items-center justify-content-between" style="gap: 1rem">
                  <div>
                    <h4>{{ report.judul }}</h4>
                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                      <h5 class="rounded-pill px-3 py-2 bg-primary-30 text-primary mr-2 mb-0">{{ report.kategori }}</h5>
                      <div class="text-muted d-flex align-items-center">
                        <i class="fa-regular fa-calendar-check fa-lg mr-2"></i>
                        <div>{{ convertDate(report.created_at) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card mt-4 p-3 bg-primary-20 rounded border-0 shadow-sm">
                  <h5 class="text-muted font-weight-bold">Masalah</h5>
                  <p class="m-0">{{ report.isi }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card p-3 bg-primary-20 rounded border-0 shadow-sm">
            <h4 class="text-dark mb-4">Kategori Laporan Populer</h4>
            <div>
              <div v-if="loadingPopular" class="text-center py-3">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div v-if="popularError" class="text-danger mb-2">Gagal memuat kategori populer</div>
                <div v-if="popularCategories.length === 0" class="text-muted">Belum ada kategori populer</div>
                <div v-else>
                  <div v-for="(cat, idx) in popularCategories" :key="`popular-${idx}`" class="d-flex align-items-center justify-content-between border-bottom py-2">
                    <div>
                      <div class="h6 text-muted">Jenis</div>
                      <div class="h6 m-0">{{ cat.kategori }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center bg-primary-100 p-4 rounded h5 text-primary">{{ cat.total }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <CTA/>

  </div>
</template>
<style scoped>
.sidebar {
  border: 1px solid #dbddf0;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
<script>
import CTA from "../../components/sistem-pengawasan/CTA.vue";
import { BASE_URL } from "../../store";
import axios from "axios";
import moment from "moment";

export default {
  components: { CTA },
  data() {
    return {
      filter: "semua",
      profile : {},
      user: {}
      ,
      popularCategories: [],
      loadingPopular: false,
      popularError: null,
    };
  },
  methods: {
    convertDate(date) {
      return moment(date).format("LLL");
    },
  },
  computed: {
    filteredReports() {
      const reports = (this.profile && Array.isArray(this.profile.reports)) ? this.profile.reports : [];
      const status = (this.filter || 'semua').toLowerCase();
      if (status === 'semua') return reports;
      return reports.filter(r => {
        if (!r || !r.status) return false;
        const s = r.status.toString().toLowerCase();
        if (status === 'diterima') return s === 'diterima';
        if (status === 'terkirim') return s === 'terkirim';
        if (status === 'ditolak') return s === 'ditolak';
        if (status === 'selesai') return s === 'selesai';
        return false;
      });
    }
  },
  created() {
    const user = JSON.parse(localStorage.getItem("user"));
    this.user = user
    
    if (!user) {
      this.$router.push("/login");
    }

    axios.get(`${BASE_URL}api/pengaduan/profile`, {
      headers: {
        Authorization: localStorage.getItem("token"),
      }
    }).then((res) => {
      this.profile = res.data;
      
    })

    // fetch popular report categories
    this.loadingPopular = true;
    axios.get(`${BASE_URL}api/pengaduan/popularCategory`, {
      headers: {
        Authorization: localStorage.getItem("token"),
      }
    })
    .then((res) => {
      if (res && res.data && Array.isArray(res.data.result)) {
        // ensure totals are integers and sort descending
        const items = res.data.result.map(item => ({
          ...item,
          total: parseInt(item.total, 10) || 0,
        })).sort((a, b) => b.total - a.total);
        // limit to top 5
        this.popularCategories = items.slice(0, 5);
      } else {
        this.popularCategories = [];
      }
      this.loadingPopular = false;
    })
    .catch((err) => {
      console.error('Failed to fetch popular categories', err);
      this.popularError = err;
      this.loadingPopular = false;
    });
  },
};
</script>
